import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetZendeskMessagingJwt } = createQueryFactory(
	"getZendeskMessagingJwt",
);
export const { useApiHook: useListEmployeeZendeskTickets } = createQueryFactory(
	"listEmployeeZendeskTickets",
);

export const { useApiHook: useGetEmployeeZendeskTicketDetails } = createQueryFactory(
	"getEmployeeZendeskTicketDetails",
);
